import styled, { css } from 'styled-components';
import { mq } from 'stylesheets/utils';
export const Header = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.sidebar};
  padding: 40px 20px 35px 20px;
`;

export const Wrapper = styled.div`
  height: 100%;
  overflow-y: auto;
`;

export const UserImage = styled.img`
  max-width: 60px;
  min-width: 60px;
  max-height: 60px;
  min-height: 60px;
  border-radius: 50%;
  margin-right: 20px;
  background-color: ${({ theme }) => theme.colors.white};
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const UserData = styled.div`
  display: flex;
  flex-direction: column;
`;

export const UserName = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.body18};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.white};
  text-transform: capitalize;
  margin-bottom: 12px;
`;

export const UserEmail = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.body12};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.white};
`;

export const Toggle = styled.button`
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.sidebar};
  border-left: none;
  border-radius: 0 4px 4px 0;
  transition: 0.3s ease all;
  display: none;
  ${mq(992)} {
    display: flex;
  }
`;

export const Div = styled.div<{
  readonly open?: boolean;
}>`
  display: flex;
  position: sticky;
  top: 80px;
  left: 0;
  height: calc(100vh - 80px);
  transition: 0.3s ease all;
  ${mq(768)} {
    height: calc(100vh - 60px);
    top: 60px;
  }
  ${mq(992)} {
    position: fixed;
    transform: translateX(-324px);
    z-index: 9;
    ${({ open }) =>
      open
        ? css`
            transform: translateX(0);
            ${Toggle} {
              background-color: ${({ theme }) => theme.colors.white};
            }
            & + div {
              & + div {
                opacity: 1;
                visibility: visible;
              }
            }
          `
        : css``}
  }
`;

export const SidebarWrapper = styled.aside<{
  readonly open?: boolean;
}>`
  max-width: 324px;
  min-width: 324px;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  width: 100%;
  /* transition: 1s ease all; */
  /* transform: translateX(-100%); */

  & + main {
    padding: 23px 28px;
    margin-left: 0;
  }

  ${({ open }) => (open ? css`` : css``)}
`;
